import React, { useState, useEffect } from 'react';
import styles from './menuHome.module.scss';
import { TabBar } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import { ApiCore } from '../../api/index';
import Home from '../home/home';
import Personal from '../personal/personal';
import Task from '../../pages/home/Home';
import AssistantGroup from '../../pagesPfizer/doctor/assistantGroup';
import Patient from '../patient/patient';
import AssistantWorkbench from '../../pagesPfizer/assistant/workbench';
import AssistantProject from '../../pagesPfizer/assistant/project';
import AssistantPatient from '../../pagesPfizer/assistant/patient';
import utils from '../../utils/utils';
import Menus from './menu.json';
import doctor_home from '../../static/images_doctor/doctor-home.svg';
import active_doctor_home from '../../static/images_doctor/active-doctor-home.svg';
import doctor_personal from '../../static/images_doctor/doctor-personal.svg';
import active_doctor_personal from '../../static/images_doctor/active-doctor-personal.svg';
import doctor_task from '../../static/images_doctor/doctor-task.svg';
import active_doctor_task from '../../static/images_doctor/active-doctor-task.svg';
import my_patient from '../../static/images_doctor/my-patient.svg';
import active_my_patient from '../../static/images_doctor/active-my-patient.svg';
import menusData from './menu.json';
//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3398857_mcvnz8cwfxq.js'
});


const api = new ApiCore();

// const existIcon = {
//     'home': <Home />,
//     'personal': <Personal />
// }

class MenuHome extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            selectedTab: 'home',
            hideMenu: true,
            hasNews: false,
            hasSign: false,
            laborHasNews: false,
            countHasNews: false,
            menuArr: []
        };
    }

    componentDidMount() {
        this.initSavedSelectedTab();
        const urlParams = utils.getUrlParams() || {};
        const tab = urlParams && urlParams.tab;
        tab && this.setState({
            selectedTab: tab
        });
        this.initUrlParams(urlParams);
        // 显示图标
        // const _data = menusData.data[0] && menusData.data[0].children;
        // if (_data) {
        //     this.setState({
        //         menuArr: _data,
        //         hideMenu: false
        //     })
        // }
        this.ifDoctorOrAssistantComlete();
        this.getMenus();
        let token = sessionStorage.getItem('token');
        if (token) {
            // 获取个人中心红点推荐
            this.getViewCount();
            //获取任务红点推荐
            this.checkSingleSign();
        }
    }

    initUrlParams(urlParams: any = {}) {
        const _urlParam = urlParams;
        // 从小程序哪个路由进来
        if (_urlParam.from) {
            localStorage.setItem('OriginUrlParam', JSON.stringify(_urlParam));
        }
        // 小程序登录后跳转
        if (_urlParam.data) {
            let _data: any = {};
            try {
                _data = JSON.parse(decodeURIComponent(_urlParam.data));
            } catch (error) {
                _data = {};
            }
            let user = {
                userName: _data.userName,
                tenantName: _data.tenantName,
                tenantCode: _data.tenantCode,
                token: _data.token,
                roleCode: _data.roleCode,
                roleCodes: _data.roleCodes,
                userCode: _data.account,
                tenantConfig: _data.tenantConfig
            }
            //保存登录信息
            sessionStorage.setItem('token', JSON.stringify(user));
            localStorage.setItem('token', JSON.stringify(user));
            localStorage.setItem('tenantCode', _data.tenantCode);
            // 小程序跳转过来时不需要
            // if (_data.tenantConfig && _data.tenantConfig.route) {
            //     this.props.history.push(_data.tenantConfig.route);
            // }
        }
    }

    /**
     * 请求异常捕获
     */
    catchFun = (promiseArr: any) => {
        return promiseArr.map((promise: any) => promise.catch((err: any) => Promise.resolve({})))
    }

    // 获取服务协议
    getViewCount = () => {
        let req1 = api.GetAgreementViewCount();
        let req2 = api.GetUserSettlementViewCount();
        let reqList = [req1, req2];
        Promise.all(this.catchFun(reqList)).then((res: any) => {
            if (res[0].code == 0 || res[1].code == 0) {
                if (res[0].data > 0) {
                    this.setState({
                        laborHasNews: true
                    });
                }
                if (res[1].data > 0) {
                    this.setState({
                        countHasNews: true
                    });
                }
                if (res[0].data > 0 || res[1].data > 0) {
                    this.setState({
                        hasNews: true
                    });
                }
            }
        });
    }


    //是否有待单病例签名
    checkSingleSign = () => {
        api.checkSingleSign().then((res: any) => {
            if (res.code == 0 && res.data) {
                this.setState({
                    hasSign: true
                });
            }
        })
    }


    // 选中选过的tab
    initSavedSelectedTab() {
        const _selectedTab = sessionStorage.getItem('HomeSelectedTab');
        if (_selectedTab) {
            this.setState({
                selectedTab: _selectedTab
            })
        }
    }

    // 是否需要完善医生、医助信息
    ifDoctorOrAssistantComlete() {
        let _urlParam = utils.getUrlParams();
        if (_urlParam.needCompleteRole === 'doctor') {
            this.ifDoctorComlete();
        } else if (_urlParam.needCompleteRole === 'assistant') {
            this.ifAssistantComlete();
        }
    }

    // 是否需要完善医生信息
    ifDoctorComlete() {
        let token = sessionStorage.getItem('token');
        if (token) {
            const urlParams = utils.getUrlParams() || {};
            const groupCode = urlParams.groupCode || '';
            const _param = {
                groupCode: urlParams.groupCode
            }
            api.getRegisterCompletedInfo(_param).then((res: any) => {
                // api.getDoctorInfo().then((res: any) => {
                if (res.code == 0) {
                    // 没有信息data为空对象
                    let _data = res.data || {};
                    sessionStorage.setItem('RegisterGetInfo', JSON.stringify(_data));
                    if (Object.keys(_data).length === 0) {
                        this.props.history.replace(`/pfizer/doctor/complete?groupCode=${groupCode}`);
                    } else if (_data.state != 2) {
                        // 注册信息审核不通过
                        this.props.history.replace(`/pfizer/auditComplete`);
                    } else {
                        sessionStorage.setItem('HomeSelectedTab', 'assistant-workbench');
                        this.setState({
                            selectedTab: 'assistant-workbench'
                        })
                    }
                }
            })
        }
    }
    // 是否需要完善医助信息
    ifAssistantComlete() {
        let token = sessionStorage.getItem('token');
        if (token) {
            const urlParams = utils.getUrlParams() || {};
            const groupCode = urlParams.groupCode || '';
            const _param = {
                groupCode: urlParams.groupCode
            }
            api.getRegisterCompletedInfo(_param).then((res: any) => {
                // api.getAssistantInfo().then((res: any) => {
                // 没有信息data为空对象
                let _data = res.data || {};
                sessionStorage.setItem('RegisterGetInfo', JSON.stringify(_data));
                if (Object.keys(_data).length === 0) {
                    this.props.history.replace(`/pfizer/assistant/complete?groupCode=${groupCode}`);
                } else if (_data.state != 2) {
                    // 注册信息审核不通过
                    this.props.history.replace(`/pfizer/auditComplete`);
                } else {
                    sessionStorage.setItem('HomeSelectedTab', 'assistant-workbench');
                    this.setState({
                        selectedTab: 'assistant-workbench'
                    })
                }
            })
        }
    }

    getMenus() {
        const token = sessionStorage.getItem('token');
        // 没有登录显示默认菜单
        if (!token) {
            const _data = Menus.data[0].children;
            this.setState({
                hideMenu: false,
                menuArr: _data
            })
            return;
        }
        if (token) {
            let mToken = JSON.parse(token);
            if (mToken.tenantConfig) {
                this.setState({
                    hideMenu: !mToken.tenantConfig.enableMenu
                })
            }
        }
        api.GetMenus({
            type: 'MNAV'
        }).then(res => {
            if (res.code + '' === '0') {
                const _dataArr = res.data[0] && res.data[0].children;
                const _data = _dataArr.map((item:any) => {
                    if (item.name === '任务') {
                        item.name = '项目';
                      }
                      return item;
                })
                // const _data = res.data[0] && res.data[0].children;
                const _selectedTab = this.state.selectedTab;
                if (_data) {
                    let matchedTab = _data.some((val: any) => {
                        if (val.icon === _selectedTab) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                    if (!matchedTab && _data[0] && _data[0].icon) {
                        sessionStorage.setItem('HomeSelectedTab', _data[0].icon);
                        this.setState({
                            selectedTab: _data[0].icon
                        })
                    }
                    this.setState({
                        menuArr: _data
                    })
                }
            }
        });
    }

    menusRender() {
        const { menuArr, hasNews, laborHasNews, countHasNews, hasSign } = this.state;
        if (!menuArr || (menuArr && menuArr.length === 0)) {
            return null;
        }
        let personalMenus: any = [];
        menuArr.some((val: any) => {
            if (val.icon === 'personal') {
                personalMenus = val.children || [];
                return true;
            }
        });
        const existIcon = {
            'home': <Home />,
            'personal': <Personal
                actionMenus={personalMenus}
                laborHasNews={laborHasNews}
                countHasNews={countHasNews}
                hasNews={hasNews}
                updateHasNews={(val: any) => { this.updateHasNews(val) }}
                switchTab={(val: any) => { this.switchTab(val) }} />,
            'task': <Task bottomMore={true} updateTitle={false} fromHomeDoctor={true} hasSign={hasSign} />,
            'patient': <Patient />,
            // 医生
            'team': <AssistantGroup />, // 我的团队
            // 医助
            'assistant-workbench': <AssistantWorkbench />,
            'assistant-patient': <AssistantPatient />,
            'assistant-project': <AssistantProject />
        }
        return (
            <TabBar
                unselectedTintColor="#989898"
                tintColor="#8A7AFB"
                barTintColor="white"
                hidden={this.state.hideMenu}
            >
                {menuArr.map((item: any) => {
                    let iconView = item.icon;
                    let IconComponent: any = '';
                    if (existIcon[item.icon]) {
                        IconComponent = existIcon[item.icon];
                    } else {
                        IconComponent = null; // IconComponent
                    }
                    if (this.state.selectedTab != item.icon) {
                        IconComponent = null;
                    }
                    let _icon = doctor_home;
                    let _selectedIcon = active_doctor_home;
                    if (item.icon === 'home') {
                        _icon = doctor_home;
                        _selectedIcon = active_doctor_home;
                    } else if (item.icon === 'personal') {
                        _icon = doctor_personal;
                        _selectedIcon = active_doctor_personal;
                    } else if (item.icon === 'task') {
                        _icon = doctor_task;
                        _selectedIcon = active_doctor_task;
                    } else if (item.icon === 'patient') {
                        _icon = my_patient;
                        _selectedIcon = active_my_patient;
                    }
                    return (
                        <TabBar.Item
                            icon={<img src={_icon} width="20" alt="" />}
                            selectedIcon={<img src={_selectedIcon} width="20" alt="" />}
                            title={<div style={{ color: this.state.selectedTab == item.icon ? '#4e88f5' : '', fontSize: '13px' }}>{item.name}</div>}
                            key={item.icon}
                            dot={(item.icon === 'personal' && hasNews) || (item.icon === 'task' && hasSign)}
                            selected={this.state.selectedTab === item.icon}
                            onPress={() => {
                                this.setState({
                                    selectedTab: item.icon
                                }, () => {
                                    window.history.replaceState({}, item.name, `#/doctor/home?tab=` + item.icon);
                                });
                                document.title = item.name;
                            }}
                        >
                            {
                                this.state.selectedTab == item.icon ? IconComponent : null
                            }
                        </TabBar.Item>
                    )
                })}
            </TabBar>
        )
    }

    updateHasNews(flag: boolean) {
        this.setState({
            hasNews: flag
        });
    }

    switchTab(tab: string) {
        this.setState({
            selectedTab: tab
        });
    }

    render() {
        return (
            <div className={`${styles.homeMenu_content} ${this.state.hideMenu ? styles.hide_menu_btn : ''}`}>
                {
                    this.menusRender()
                }
            </div >
        )
    };
}
export default MenuHome;